import { Box } from '#app/components/Box.js';
import { APP_NAME } from '#app/utils/constants.js';

export default function ResponsibleDisclosure() {
  return (
    <div className="pb-20 pt-20">
      <div className="mx-auto w-full px-8 sm:px-20 md:px-32">
        <Box>
          <div>
            <h1 className="mb-4 text-3xl font-bold">Responsible Disclosure Policy</h1>
            <p className="mb-4">
              At <strong>{APP_NAME}</strong>, we take the security of our systems and user data very seriously. We value
              the contributions of security researchers and the broader security community, and we are committed to
              addressing security vulnerabilities promptly and effectively.
            </p>

            <h2 className="mb-2 text-2xl font-semibold">Reporting a Vulnerability</h2>
            <p className="mb-2">
              If you believe you have discovered a security vulnerability in any of our systems, products, or services,
              we encourage you to let us know right away. We appreciate your efforts to help us maintain a safe and
              secure environment for our users.
            </p>
            <p className="mb-4">
              To report a vulnerability, please email us at{' '}
              <a href="mailto:security@provenvalor.com" className="font-bold underline">
                security@provenvalor.com
              </a>
              .
            </p>

            <p className="mb-2 italic text-slate-700">Include the following details in your report:</p>
            <ul className="mb-4 ml-8 list-inside list-disc">
              <li>A description of the vulnerability</li>
              <li>The steps required to reproduce the issue</li>
              <li>Any proof-of-concept code or screenshots (if available)</li>
              <li>Your name and contact information (optional, but helpful for follow-up)</li>
            </ul>

            <h2 className="mb-2 text-2xl font-semibold">Our Commitment</h2>
            <p className="mb-2 italic text-slate-700">
              We are committed to working with security researchers who submit vulnerability reports to us in good
              faith. As part of this commitment, we will:
            </p>
            <ul className="mb-4 ml-8 list-inside list-disc">
              <li>Acknowledge receipt of your vulnerability report as soon as we can.</li>
              <li>Provide an estimated timeline for addressing the vulnerability.</li>
              <li>
                Notify you when the vulnerability has been addressed and, if applicable, publicly disclose the details
                of the fix.
              </li>
            </ul>

            <h2 className="mb-2 text-2xl font-semibold">Guidelines</h2>
            <p className="mb-2 italic text-slate-700">To protect our users and systems, we ask that you:</p>
            <ul className="mb-4 ml-8 list-inside list-disc">
              <li>Give us a reasonable amount of time to address the issue before disclosing it publicly.</li>
              <li>
                Avoid violating privacy, destroying data, or disrupting our services while researching the
                vulnerability.
              </li>
              <li>Make a good faith effort to avoid privacy violations and destruction of data.</li>
              <li>Only interact with accounts you own or have explicit permission to test.</li>
            </ul>

            <h2 className="mb-2 text-2xl font-semibold">Legal</h2>
            <p className="mb-4">
              We will not take legal action against security researchers who report vulnerabilities to us in good faith
              and follow the guidelines outlined in this policy. However, we reserve the right to take legal action if
              there is evidence of malicious intent, fraud, or a violation of applicable laws.
            </p>

            <h2 className="mb-2 text-2xl font-semibold">Recognition</h2>
            <p className="mb-4">
              We recognize and appreciate the efforts of security researchers who help us improve our security. While we
              do not offer a formal bug bounty program, we may, at our discretion, provide recognition and/or rewards
              for significant vulnerability reports.
            </p>

            <p>
              Thank you for helping us keep <strong>{APP_NAME}</strong> and our users safe.
            </p>
          </div>
        </Box>
      </div>
    </div>
  );
}
